import { Controller } from "@hotwired/stimulus"

/**
 * Analytics Controller
 *
 * Pushes custom events to dataLayer for GA4/GTM tracking.
 *
 * Usage:
 *
 * Manual trigger (on click/submit):
 *   data-controller="analytics"
 *   data-action="click->analytics#track"
 *   data-analytics-event-value="contact_clicked"
 *   data-analytics-params-value='{"business_slug":"acme-roofing","contact_type":"phone"}'
 *
 * Auto-trigger on page load (connect):
 *   data-controller="analytics"
 *   data-analytics-event-value="listing_viewed"
 *   data-analytics-params-value='{"business_slug":"acme-roofing","city":"baltimore","state":"MD"}'
 *   data-analytics-auto-track-value="true"
 */
export default class extends Controller {
  static values = {
    event: String,       // Event name (required)
    params: Object,      // Event parameters (optional)
    autoTrack: Boolean   // Auto-fire on connect (default: false)
  }

  connect() {
    if (this.autoTrackValue) {
      this.track()
    }
  }

  track() {
    if (!this.hasEventValue) {
      console.warn('[analytics_controller] No event name provided')
      return
    }

    // Check if dataLayer exists
    if (typeof window.dataLayer === 'undefined') {
      console.warn('[analytics_controller] window.dataLayer not found')
      return
    }

    const eventData = {
      event: this.eventValue,
      ...this.paramsValue
    }

    // Tracking is synchronous; let the browser handle the original action.
    window.dataLayer.push(eventData)
  }

  updateQuery(event) {
    // Update params with current query value
    if (this.hasParamsValue) {
      this.paramsValue.query = event.target.value
    }
  }

  updateRating(event) {
    if (this.hasParamsValue) {
      this.paramsValue.rating = event.target.value
    }
  }
}
